import { render, staticRenderFns } from "./CmsManuallyLocalization.vue?vue&type=template&id=4d71739d&scoped=true&"
import script from "./CmsManuallyLocalization.vue?vue&type=script&lang=js&"
export * from "./CmsManuallyLocalization.vue?vue&type=script&lang=js&"
import style0 from "./CmsManuallyLocalization.vue?vue&type=style&index=0&id=4d71739d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d71739d",
  null
  
)

export default component.exports